import { RootState } from '../../../index';

export const currenciesSelector = (state: RootState) => state.settings.otherOptions.currencies;

export const otherOptionsSelector = (state: RootState) => state.settings.otherOptions.options;

export const supportOptionsSelector = (state: RootState) => state.settings.otherOptions.supportOptions;
